export default function itemLicitacao () {
    
    let itemLicitacao = {};
    itemLicitacao.itemLicitacaoId= null;
    itemLicitacao.arquivo= "";
    itemLicitacao.descricao= "";
    itemLicitacao.data= null;
    itemLicitacao.externo= "";
    itemLicitacao.linkExterno= "";

    return itemLicitacao;
}
